import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from '@/components/ui/sonner';

import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import ServicesPage from '@/pages/ServicesPage';
import ServiceDetailPage from '@/pages/ServiceDetailPage';
import ProjectsPage from '@/pages/ProjectsPage';
import BlogPage from '@/pages/BlogPage';
import BlogDetailPage from '@/pages/BlogDetailPage';
import ContactPage from '@/pages/ContactPage';
import AppointmentPage from '@/pages/AppointmentPage';
import AdminLoginPage from '@/pages/admin/AdminLoginPage';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminBlogs from '@/pages/admin/AdminBlogs';
import AdminProjects from '@/pages/admin/AdminProjects';
import AdminAppointments from '@/pages/admin/AdminAppointments';
import SurveyPage from './pages/SurveyPage';
import AdminSurveys from './pages/admin/AdminSurveys';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/hakkimizda" element={<AboutPage />} />
            <Route path="/hizmetler" element={<ServicesPage />} />
            <Route path="/hizmetler/:slug" element={<ServiceDetailPage />} />
            <Route path="/islerimiz" element={<ProjectsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogDetailPage />} />
            <Route path="/iletisim" element={<ContactPage />} />
            <Route path="/randevu" element={<AppointmentPage />} />
            <Route path="/anket" element={<SurveyPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/blog" element={<AdminBlogs />} />
            <Route path="/admin/islerimiz" element={<AdminProjects />} />
            <Route path="/admin/randevular" element={<AdminAppointments />} />
            <Route path="/admin/anketler" element={<AdminSurveys />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
